export const TABLE_UPDATE = "LOCATIONS/TABLE_UPDATE";
export const FETCH_SUCCESS = "LOCATIONS/FETCH_SUCCESS";

const types = {
    DESTROY_FAILED: "LOCATIONS/DESTROY_FAILED",
    DESTROY_REQUEST: "LOCATIONS/DESTROY_REQUEST",
    DESTROY_SUCCESS: "LOCATIONS/DESTROY_SUCCESS",

    FETCH_FAILED: "LOCATIONS/FETCH_FAILED",
    FETCH_REQUEST: "LOCATIONS/FETCH_REQUEST",
    FETCH_SUCCESS,

    GET_FAILED: "LOCATIONS/GET_FAILED",
    GET_REQUEST: "LOCATIONS/GET_REQUEST",
    GET_SUCCESS: "LOCATIONS/GET_SUCCESS",

    PATCH_FAILED: "LOCATIONS/PATCH_FAILED",
    PATCH_REQUEST: "LOCATIONS/PATCH_REQUEST",
    PATCH_SUCCESS: "LOCATIONS/PATCH_SUCCESS",
    
    STORE_FAILED: "LOCATIONS/STORE_FAILED",
    STORE_REQUEST: "LOCATIONS/STORE_REQUEST",
    STORE_SUCCESS: "LOCATIONS/STORE_SUCCESS",

    UPDATE_FAILED: "LOCATIONS/UPDATE_FAILED",
    UPDATE_REQUEST: "LOCATIONS/UPDATE_REQUEST",
    UPDATE_SUCCESS: "LOCATIONS/UPDATE_SUCCESS",
    TABLE_UPDATE,
};

export default types;
